import { type GenericMap } from "@common/declarations";
import Network from "@common/modules/network/types";
import { isNull, isUndefined } from "lodash";
import { type Data } from "./types";

const isValue = (x: any) => !isNull(x) && !isUndefined(x);

export const isMoney = (by: Data.NetworkVolumeAggregateBy): boolean => {
  switch (by) {
    case "commissionValue":
    case "earnings":
    case "leadershipEarnings":
    case "retailCommissionValue":
    case "value":
      return true;
    default:
      return false;
  }
};

export const doesRankMatch = (
  filter: Data.NetworkVolumeFilter,
  rankIdToOrder: GenericMap<number>,
  rankAssignmentOrder: number | null
) =>
  (!isValue(filter.from) || (isValue(rankAssignmentOrder) && rankAssignmentOrder! >= rankIdToOrder[filter.from!])) &&
  (!isValue(filter.to) || (isValue(rankAssignmentOrder) && rankAssignmentOrder! <= rankIdToOrder[filter.to!]));

const filterInner = (
  data: Data.Api.GenealogyCycleAggregate[],
  filter: Data.NetworkVolumeFilter,
  rankOptions: Network.Api.RankOptionItem[]
): Data.Api.GenealogyCycleAggregate[] => {
  switch (filter.by) {
    case "breakawayLevel":
    case "differentialLevel":
    case "leg":
    case "level":
      return data.filter(
        (x) =>
          (!isValue(filter.from) || (isValue(x[filter.by]) && x[filter.by]! >= filter.from!)) &&
          (!isValue(filter.to) || (isValue(x[filter.by]) && x[filter.by]! <= filter.to!))
      );
    case "rankName": {
      const rankIdToOrder = rankOptions.reduce((res, x) => ({ ...res, [x.value]: x.assignmentOrder }), {});
      return data.filter((x) => doesRankMatch(filter, rankIdToOrder, x.rankAssignmentOrder));
    }
  }
};

export const filterAggregates = (
  data: Data.Api.GenealogyCycleAggregate[],
  { filter, group, genealogyTypeId, volumeTypes }: Data.NetworkVolumeConfig,
  rankOptions: Network.Api.RankOptionItem[]
): Data.Api.GenealogyCycleAggregate[] => {
  let filtered = data;

  if (genealogyTypeId) {
    filtered = filtered.filter((x) => x.genealogyTypeId === genealogyTypeId);
  }

  if (volumeTypes) {
    filtered = filtered.filter(
      (x) =>
        (x.isBanked && volumeTypes.includes("Banked")) ||
        (x.isPersonal === true && volumeTypes.includes("Personal")) ||
        (x.isPersonal === false && volumeTypes.includes("Team"))
    );
  }

  filtered = filterInner(filtered, group, rankOptions);

  if (filter && (isValue(filter.from) || isValue(filter.to))) {
    filtered = filterInner(filtered, filter, rankOptions);
  } else {
    // exception: when grouping by rank w/p filtering, we only need to count records with level >= 1
    if (group.by === "rankName") {
      filtered = filtered.filter((x) => !!x.level);
    }
  }

  return filtered;
};
